export const Email = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 64 53">
            <path
                d="M59.03.563A4.97 4.97 0 0 1 64 5.532L36.257 27.081a6.94 6.94 0 0 1-8.514 0L0 5.533A4.97 4.97 0 0 1 4.97.563z"
                opacity=".5"
            />
            <path d="M0 5.535V44.68a7.456 7.456 0 0 0 7.456 7.456h49.088A7.456 7.456 0 0 0 64 44.68V5.535l-27.426 21.3a7.456 7.456 0 0 1-9.148 0z" />
        </svg>
    );
};
